export default class Locale {
  static numberFormatLocale(): string {
    return 'de';
  }

  static dateAdapterLocale(): string {
    return 'de-DE';
  }

  static momentLocale(): string {
    return 'de';
  }

  static firstDayOfWeek(): number {
    return 1;
  }
}
